
import { defineComponent, computed, ref } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'
import { useOrganizationModule } from '@/modules/organizations'

export default defineComponent({
    name: 'organizations-form-field-business-id',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    },
    setup () {
        const { validations: { requiredRule } } = useFormModule()
        const { checkBusinessIdIsValid, checkBusinessIdIsAvailable, ValidityResultType } = useOrganizationModule()

        const response = ref({ isValid: 0, isAvailable: 0 })
        const businessIdValidityAndAvailabilityRule = async (value: string) => {
            if (value && value !== '') {
                response.value.isValid = (await checkBusinessIdIsValid(value)).validityResult
                response.value.isAvailable = (await checkBusinessIdIsAvailable(value)).validityResult
            }
            if (response.value.isValid === ValidityResultType.FAKE) {
                return true
            }
            if (response.value.isValid === ValidityResultType.INVALID) {
                return 'Business Id has wrong format'
            } else if (response.value.isAvailable === ValidityResultType.INVALID) {
                return 'Business id is already used. Please provide a unique business id'
            }
            return true
        }

        const temporaryBusinessIdWarning = computed(() => {
            return response.value.isValid === ValidityResultType.FAKE
                ? 'This id is potentially deprecated and is used as temporary solution' : null
        })

        return {
            requiredRule,
            businessIdValidityAndAvailabilityRule,
            temporaryBusinessIdWarning
        }
    }
})
